var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticClass:"overlay-display",attrs:{"show":_vm.show,"rounded":"sm"},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"text-center"},[_c('b-icon',{attrs:{"icon":"stopwatch","font-scale":"3","animation":"cylon"}}),_c('p',{attrs:{"id":"cancel-label"}},[_vm._v("Please wait...")])],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }